import { render, staticRenderFns } from "./AddChatTemplatesCategoryForm.vue?vue&type=template&id=78da99e6&scoped=true"
import script from "./AddChatTemplatesCategoryForm.vue?vue&type=script&lang=js"
export * from "./AddChatTemplatesCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da99e6",
  null
  
)

export default component.exports